import { APIStatus } from "@application/common/enums/api-status";
import { createSlice } from "@reduxjs/toolkit";
import { createJobCategoryAsync, getAllJobCategoriesAsync, getJobCategoryByIdAsync, updateJobCategoryAsync } from "./jobcategoryThunk";
const initialState = {
    status: APIStatus.IDLE,
};
export const jobCategorySlice = createSlice({
    name: 'jobCategory',
    initialState,
    reducers: {
        clearUpdateJobCategory: (state) => {
            state.updateJobCategory = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllJobCategoriesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllJobCategoriesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.jobCategories = action.payload;
        })
            .addCase(getAllJobCategoriesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createJobCategoryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createJobCategoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.jobCategory = action.payload;
        })
            .addCase(createJobCategoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateJobCategoryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateJobCategoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.jobCategory = action.payload;
        })
            .addCase(updateJobCategoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getJobCategoryByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getJobCategoryByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateJobCategory = action.payload;
        })
            .addCase(getJobCategoryByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default jobCategorySlice.reducer;
export const { clearUpdateJobCategory } = jobCategorySlice.actions;
